import { gql } from '@apollo/client';

export default gql`
  mutation updateTasksEmployee($ids: [String], $employee: EmployeeInput) {
    updateTasksEmployee(ids: $ids, employee: $employee) {
      ok
      message
      error
    }
  }
`;
